import { render, staticRenderFns } from "./MonthlyChartCard.vue?vue&type=template&id=0bce34da&scoped=true"
import script from "./MonthlyChartCard.vue?vue&type=script&lang=js"
export * from "./MonthlyChartCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bce34da",
  null
  
)

export default component.exports